"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamerStatus = void 0;
var StreamerStatus;
(function (StreamerStatus) {
    StreamerStatus["New"] = "New";
    // Checking during ice gathering.
    StreamerStatus["Checking"] = "Checking";
    // Connected when a connection has been established.
    StreamerStatus["Connected"] = "Connected";
    // Disconnected occurs when a connection is interrupted.
    StreamerStatus["Disconnected"] = "Disconnected";
    // NotSupported if WebRTC is supported, but lacks the correct capabilities.
    StreamerStatus["NotSupported"] = "NotSupported";
    // Failed due to connection failure, either by signalling or peer connection.
    StreamerStatus["Failed"] = "Failed";
    // Completed during active streamed video.
    StreamerStatus["Completed"] = "Completed";
    // Streamer peer connection closed
    StreamerStatus["Closed"] = "Closed";
    // Streamer contribution withdrawn
    StreamerStatus["Withdrawn"] = "Withdrawn";
})(StreamerStatus = exports.StreamerStatus || (exports.StreamerStatus = {}));
//# sourceMappingURL=StreamerStatus.js.map